/* ===== Подключение компонентов React ===== */
import { useState, useEffect } from "react";

/* ===== Подключение локальных компонентов ===== */
import Hero from "../../components/blocks/Hero";                    /* Блок после шапки меню */
import Reliable from "../../components/blocks/Reliable";            /* Блок после Hero решение проблем */
import Problems from "../../components/blocks/Problems/Problems";   /* Блок после Reliable Описывание проблем клиента */
import Advantages from "../../components/blocks/Advantages";        /* Блок послелу Problems Наши преииущества */   
import Actions from "../../components/blocks/Actions/Actions";      /* Блок после Advantages Наши Акции */
import OnlimeGsm from "../../components/blocks/OnlimeGsm/OnlimeGsm"; /* Блок после Actions Онлайн отслеживание топлива */
import Comandos from "../../components/blocks/Comands";              /* Блок после OnlimeGsm Наша Команда */ 
import Faq from "../../components/blocks/Faq";                       /* Блок после Comandos Ответы и Вопросы */
import Reviews from "../../components/blocks/Reviews/Reviews";       /* Блок после Faq Отзывы */
import Offers from "../../components/blocks/Offers/Offers";          /* Блок после Reviews Акции */   
import FormBase from "../../components/ui/Forms/FormBase";           /* Блок после Offers Формма отправки */

function Home(){

    const [selectedOrder, setSelectedOrder] = useState(null);

    useEffect(() => {
    if (!selectedOrder) return;

    // скролл ПОСЛЕ того, как форма уже отрисовала orderPreview
    requestAnimationFrame(() => {
      const el = document.querySelector("#order-form");
      if (!el) return;

      const header = document.querySelector("header");
      const offset = (header?.offsetHeight || 0) + 16;

      const y = el.getBoundingClientRect().top + window.pageYOffset - offset;
      window.scrollTo({ top: y, behavior: "smooth" });

      // фокус в телефон
      setTimeout(() => {
        document.querySelector('input[name="phone"]')?.focus();
      }, 500);
    });
  }, [selectedOrder]);

    return(
        <section id="home">
            <Hero />
            <Reliable />
            <Problems />
            <Advantages />
            <Actions />
            <OnlimeGsm />
            <Comandos />
            <Faq />
            <Reviews />
            {/* <Offers onOrderSelect={setSelectedOrder} /> */}
            <FormBase selected={selectedOrder} />
        </section>
    )
}


export default Home;